// Shared across every proposal: the pricing-strategy teaching content (showing ladder and the three strategies).
// Edit here once; every client's page picks it up.

export const showingLadder = [
  { level: "No showings", meaning: "Priced 11 to 20% high" },
  { level: "Low showings", meaning: "Priced 6 to 10% high" },
  { level: "Steady showings", meaning: "Priced 2 to 5% high" },
  { level: "An offer", meaning: "Priced right" },
];

export const showingLadderCaption = "Priced right, a home usually sells at or above list in 1 to 2 weeks.";

export const pricingStrategies = [
  { name: "Price low", text: "Aim for multiple offers. Could leave money on the table." },
  {
    name: "Price at market value",
    text: "Usually the best way to draw offers and net the most, with the least disruption to your life.",
    recommended: true,
    tag: "My usual recommendation",
  },
  {
    name: "Stretch price",
    text: "Start high and come down if it doesn't sell. Buyers start asking what's wrong, and you end up chasing the market down.",
  },
];
